import React, { useState, useEffect } from 'react';
import { FaVideo, FaPlayCircle, FaTags } from 'react-icons/fa';
import { HomeProgressBar } from '../../Services/allApi';

function ProgressChart({ result, apicalled, apicalledTwo }) {
  const [videoCountdown, setVideoCountdown] = useState(0);
  const [timelineCountdown, setTimelineCountdown] = useState(0);
  const [tagsCountdown, setTagsCountdown] = useState(0);
  const [totalVideos, setTotalVideos] = useState(0);
  const [timelineAdded, setTimelineAdded] = useState(0);
  const [tagsAdded, setTagsAdded] = useState(0);
  const [token, setToken] = useState('');

  useEffect(() => {
    setToken(sessionStorage.getItem('access_token'));
  }, []);

  useEffect(() => {
    if (result && result.data) {
      const totalVideos = result.data.metrics_total_videos ?? 0;
      const timelineAdded = result.data.metrics_published_for ?? 0;
      const tagsAdded = result.data.metrics_tags_added_for ?? 0;
      setTotalVideos(totalVideos);
      setTimelineAdded(timelineAdded);
      setTagsAdded(tagsAdded);
      startCountdown(totalVideos, timelineAdded, tagsAdded);
    } else {
      setVideoCountdown(0);
      setTimelineCountdown(0);
      setTagsCountdown(0);
    }
  }, [result, apicalled, apicalledTwo]);

  const startCountdown = (totalVideos, timelineAdded, tagsAdded) => {
    const videoTimer = setInterval(() => {
      setVideoCountdown((prevCountdown) => {
        if (prevCountdown >= totalVideos) {
          clearInterval(videoTimer);
          return totalVideos;
        }
        return prevCountdown + 50;
      });
    }, 1);

    const timelineTimer = setInterval(() => {
      setTimelineCountdown((prevCountdown) => {
        if (prevCountdown >= timelineAdded) {
          clearInterval(timelineTimer);
          return timelineAdded;
        }
        return prevCountdown + 50;
      });
    }, 1);

    const tagsTimer = setInterval(() => {
      setTagsCountdown((prevCountdown) => {
        if (prevCountdown >= tagsAdded) {
          clearInterval(tagsTimer);
          return tagsAdded;
        }
        return prevCountdown + 50;
      });
    }, 1);
  };

  return (
    <div className='flex flex-row w-full h-full justify-evenly items-center space-x-4'>
      <div className='flex flex-col justify-center items-center w-1/3 bg-gradient-to-r from-blue-gray-400 via-blue-gray-600 to-blue-gray-800 p-3 rounded-lg shadow-lg transform transition-transform hover:scale-105'>
        <FaVideo className='text-gray-200 text-3xl mb-1' />
        <div className='text-lg font-semibold text-gray-200 mb-2'>Videos Added</div>
        <div className=''>
          <p className='text-4xl font-extrabold text-gray-200' >{videoCountdown}</p>
        </div>
      </div>

      <div className='flex flex-col justify-center items-center w-1/3 bg-gradient-to-r from-blue-gray-400 via-blue-gray-600 to-blue-gray-800 p-3 rounded-lg shadow-lg transform transition-transform hover:scale-105'>
        <FaTags className='text-gray-200 text-3xl mb-1' />
        <div className='text-lg font-semibold text-gray-200 mb-2'>Tags Added</div>
        <div className=''>
          <p className='text-4xl font-extrabold text-gray-200'>{tagsCountdown}</p>
        </div>
      </div>

      <div className='flex flex-col justify-center items-center w-1/3 bg-gradient-to-r from-blue-gray-400 via-blue-gray-600 to-blue-gray-800 p-3 rounded-lg shadow-lg transform transition-transform hover:scale-105'>
        <FaPlayCircle className='text-gray-200 text-3xl mb-1' />
        <div className='text-lg font-semibold text-gray-200 mb-2'>Videos Published</div>
        <div className=''>
          <p className='text-4xl font-extrabold text-gray-200'>{timelineCountdown}</p>
        </div>
      </div>
    </div>
  );
}

export default ProgressChart;
